module.exports = {
  title: "RBR750P",
  axiosPrefix: "/dniapi",
  type: "orbi", // Available values: 'orbi', 'orbi'
  style: "gui-2-1", // Reserved. Available values: 'gui-2-1'
};
